const maintenancesStatusLabel = {
  title: 'Em Progresso',
  title1: 'Cancelada',
  title2: 'Concluída',
  title3: 'Agendada',
  title4: 'Pendente',
  title5: 'Vencida',
  title6: 'Em Atraso',
};

export default maintenancesStatusLabel;